module.exports = __webpack_public_path__ + "static/img/40018 (2).21739be.webp";


//////////////////
// WEBPACK FOOTER
// ./src/assets/40000/40018 (2).webp
// module id = DYV2
// module chunks = 14